<template>
  <div class="EventTaskFormComponent">

    <b-form>
      <p>{{lang.label_Reason}}:</p>
      <b-form-group id="input-group-Info">
        <span v-if="data.reasonVisible == true">
          <b-form-textarea id="textarea_Reason" v-model="reason" :placeholder="lang.placeholder_Reason" rows="3"
            max-rows="10">
          </b-form-textarea>

          <br>
        </span>
        <span
          v-if="data.changeRevisionOfDependentPartsVisible == true && isLibraries == true && isParts == false && data.isSecondLevel == false">
          <b-form-checkbox v-model="changeRevisionOfDependentParts" value="true" unchecked-value="false">
            {{lang.label_ChangeRevision}}
          </b-form-checkbox>
          <br>
        </span>
        <!-- <span
          v-if="data.changeRevisionOfDependentPartsVisible == true && isLibraries == true && isParts == false && data.isSecondLevel == true">
          <b-form-checkbox v-model="changeRevisionOfDependentParts" value="true" unchecked-value="false">
            Changing a revision in the library should change the revision in all libraries where it is used. 
          </b-form-checkbox>
          
          
          <br>
        </span> -->
        <span 
          v-if="data.indicatedUserIdVisible == true && (isLibraries == true || isParts == true) && data.isSecondLevel == false && globalSettings.doubleApproval == true && is4eyesRuleOff == false">
          <b-form-group :label="lang.label_Users+':'">
            <b-form-select v-model="indicatedUserId" :options="usersList" size="sm" class="mt-3">
            </b-form-select>

          </b-form-group>
        </span>
      </b-form-group>

    </b-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "EventTaskFormComponent",
  components: {

    

  },
  props:{
    lang: Object,
    data: Object
  },
  data () {
    return {
      
      reason: "",
      changeRevisionOfDependentParts: false,
      indicatedUserId: null,
      usersList: [
        {
          value: null,
          text: "Choose a user..."
        }
      ],
    }
  },
  computed: {
    ...mapGetters({

      currentUser: 'currentUser',
      globalSettings: 'globalSettings'

    }),
    isLibraries() {
      return this.$store.getters.sectionPrefix == "lm";
    },
    isParts() {
      return this.$store.getters.sectionPrefix == "pm";
    },
    is4eyesRuleOff() {
      if (this.$store.getters.sectionPrefix == "lm") {
        return this.$store.getters.selectedTreeLibraryItemObject.is4eyesRuleOff;
      }
      if (this.$store.getters.sectionPrefix == "pm") {
        return this.$store.getters.selectedTreeItemObject.is4eyesRuleOff;
      }
    }
  },
  created() {

    let vue = this;


    this.$store.dispatch('u_getUsersBasic')
      .then((result) => {
        console.log(result.data)


        if (result.status == "OK") {
          vue.createUsersList(result.data);


        } else {

        }

      })


    const obj = {
      reason: this.reason,
      changeRevisionOfDependentParts: this.changeRevisionOfDependentParts,
      indicatedUserId: this.indicatedUserId
    }
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_setEventTaskForm", obj);

  },
  updated(){
    const obj = {
      reason: this.reason,
      changeRevisionOfDependentParts: this.changeRevisionOfDependentParts,
      indicatedUserId: this.indicatedUserId
    }
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_setEventTaskForm", obj);
    
    
  },
  methods: {
    createUsersList(data) {

      for (let i = 0, lei = data.length; i < lei; i++) {
        if (this.currentUser.userId != data[i].userId) {

          const obj = {
            value: data[i].userId,
            text: data[i].FirstName + " " + data[i].LastName
          }
          if (data[i].Role == "Admin" || data[i].Role == "Approver") {
            this.usersList.push(obj);
          }
          
        }

      }

    }
  }
}
</script>
<style lang="scss">

  .EventTaskFormComponent{

  }



</style>



// WEBPACK FOOTER //
// src/components/shared/EventTaskFormComponent.vue